import React, { useEffect, createElement } from 'react';
import { GeoPricingProvider } from './hooks/useGeoPricing';
import { OfferBar } from './components/OfferBar';
import { ProgressBar } from './components/ProgressBar';
import { HeroSection } from './components/HeroSection';
import { EbookSection } from './components/EbookSection';
import { PurchaseSection } from './components/PurchaseSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  useEffect(() => {
    // Meta Pixel
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    ;
    (window as any).fbq('init', '727647699905216');
    (window as any).fbq('track', 'PageView');
    // Set page title
    document.title = '🥗 Tus Recetas Saludables';
  }, []);
  return <GeoPricingProvider data-id="element-0">
      <div className="w-full min-h-screen bg-cream font-poppins text-dark-gray" data-id="element-1">
        <OfferBar data-id="element-2" />
        <ProgressBar data-id="element-3" />

        <main data-id="element-4">
          <HeroSection data-id="element-5" />
          <EbookSection data-id="element-6" />
          <PurchaseSection data-id="element-7" />
          <BonusSection data-id="element-8" />
          <TestimonialsSection data-id="element-9" />
          <GuaranteeSection data-id="element-10" />
          <FAQSection data-id="element-11" />
          <FinalOfferSection data-id="element-12" />
        </main>

        <Footer data-id="element-13" />
        <StickyCTA data-id="element-14" />
      </div>
    </GeoPricingProvider>;
}